import PrivateFeedbackApi from '@/api/private-feedback'

const makeFeedbackV2Request = (payload) => {
  return {
    createdBy: payload.createdBy,
    presentationId: payload.presentationId,
    rating: payload.voteCount,
    comment: payload.title,
    name: payload.audienceName,
    color: payload.audienceColor,
  }
}

const sendFeedbackAction = async (_, payload) => {
  const req = makeFeedbackV2Request(payload)
  await PrivateFeedbackApi.sendFeedbackV2(req)
}

export default {
  sendFeedbackAction,
}
